import React from 'react';
import MaterialsDatabase from '../components/materials/MaterialsDatabase';

const MaterialsDatabasePage: React.FC = () => {
  return <MaterialsDatabase />;
};

export default MaterialsDatabasePage;